// extracted by mini-css-extract-plugin
export default {"tagline":"QuestionsMoon_tagline__V2xCN","footerContentSubText":"QuestionsMoon_footerContentSubText__vkjxm"};